export function isProduction() {
  return process.env.NODE_ENV === 'production';
}

export function isNewAlgoliaIndexesPresent() {
  const expertsIndexName = process.env.REACT_APP_ALGOLIA_EXPERTS_AGGREGATOR_INDEX_NAME;
  const contentIndexName = process.env.REACT_APP_ALGOLIA_CONTENT_AGGREGATOR_INDEX_NAME;

  return Boolean(expertsIndexName) && Boolean(contentIndexName);
}
